export const getTenantIdFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search); 
  return urlParams.get('tenant');
};

// GTIN mod-10 check digit, the same math as the backend's code resolver.
export const gtinCheckDigit = (digits) => {
  const sum = [...digits].reverse().reduce(
    (total, digit, index) => total + Number(digit) * (index % 2 === 0 ? 3 : 1),
    0
  );
  return String((10 - (sum % 10)) % 10);
};

export const productCodeWidth = (settings) => (
  settings.length - settings.prefix.length - (settings.checkDigit ? 1 : 0)
);

// Display-only preview; the server builds the real code.
export const previewProductCode = (settings, number) => {
  const digits = String(number ?? '').trim().replace(/^0+(?=\d)/, '');
  const width = productCodeWidth(settings);
  if (!/^\d+$/.test(digits) || digits.length > width) return '';
  const body = settings.prefix + digits.padStart(width, '0');
  return settings.checkDigit ? body + gtinCheckDigit(body) : body;
};
